
  import ScreenSize from '@/mixins/ScreenSize';
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    filters: {
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    mixins: [ScreenSize],
    props: {
      card: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        imageUrl: process.env.NUXT_ENV_FALLBACK_IMAGE,
      };
    },
    created() {
      if (this.card.image) {
        this.imageUrl = prepareImageUrl(this.card.image.url);
      }
    },
  };
